import React from 'react'
import { formatValueWithPattern } from '../../utils/formatter'
import { FORMAT_PATTERN } from '../../utils/constants'

interface ViewComponentProps {
  label: string
  isPhone?: boolean
  data: string | undefined | number[] | string[] | boolean | null // Adjust type according to your needs
}

const ViewComponent: React.FC<ViewComponentProps> = ({
  label,
  data,
  isPhone = false,
}) => {
  let displayData = ''

  if (data !== undefined && data !== null) {
    displayData = Array.isArray(data)
      ? data.join(', ')
      : !isNaN(parseFloat(data as string)) && isPhone
      ? formatValueWithPattern(
          (data as string) || '',
          FORMAT_PATTERN.PHONE_INPUT
        )
      : String(data)
  }

  return (
    <div className="min-h-9 w-full mr-8">
      <label className="block text-xs text-accent-900">{label}</label>
      <div className="font-primary block text-xs font-light text-accent-800">
        {displayData}
      </div>
    </div>
  )
}

export default ViewComponent
